import { SubscriptionTypeEnum } from '@/shared/api';

export const plans: Record<SubscriptionTypeEnum, any> = {
	[SubscriptionTypeEnum.Month]: {
		name: 'Перед собесом',
		description: 'Подготовься перед algo-собесом и повтори основные задачи!',
	},
	[SubscriptionTypeEnum.Semiannual]: {
		name: 'Глубокое погружение',
		description:
			'Глубоко изучи алгоритмы и структуры данных и используй знания не только на собесах, но и в работе!',
	},
	[SubscriptionTypeEnum.Year]: {
		name: 'Глубокое погружение',
		description:
			'Глубоко изучи алгоритмы и структуры данных и используй знания не только на собесах, но и в работе!',
	},
	[SubscriptionTypeEnum.Quarter]: {
		name: 'Глубокое погружение',
		description:
			'Глубоко изучи алгоритмы и структуры данных и используй знания не только на собесах, но и в работе!',
	},
	[SubscriptionTypeEnum.Online]: {
		name: 'Глубокое погружение',
		description:
			'Глубоко изучи алгоритмы и структуры данных и используй знания не только на собесах, но и в работе!',
	},
};
